import { appRoute } from "routes/app/home.runtime"
import { Account } from "./account"

appRoute.register("account", <Account $lazy />)
